import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { CloseLight, Action } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';

const ProvidersFilter = (): JSX.Element => {
	const [state] = useStore();
	const { providers, filters } = state;
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		setFiltersOptions(updateOptions);
		onFilter([
			{ name: 'game_provider_ids', value: filterValue },
			{ name: 'game_ids', value: '' },
		]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		setFiltersOptions(cloneDeep(providers));
		onFilter([
			{ name: 'game_provider_ids', value: '' },
			{ name: 'game_ids', value: '' },
		]);
	};

	const onSelectAll = () => {
		if (!providers || !providers.length) return;
		const allValues = providers.map((p: PropertyType) => p.value).join(',');
		setFiltersOptions(selectPreselectedOptions(providers, allValues));
		onFilter([
			{ name: 'game_provider_ids', value: allValues },
			{ name: 'game_ids', value: '' },
		]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (providers) {
			setFiltersOptions(cloneDeep(providers));
		}
	}, [providers]);

	useEffect(() => {
		const filter = find(filters, ['name', 'game_provider_ids'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(providers, filter));
	}, [filters]);

	return (
		<Action
			label='Providers'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='providers-filter'
		>
			<FilterDropdown
				data={filterOptions}
				onChange={onFilterChange}
				isSearchable
				enableSelectAll
				onSelectAll={onSelectAll}
				selectAllLabel='Select All'
			/>
		</Action>
	);
};

export { ProvidersFilter };
